import React, { ReactNode } from "react";
import { Button, PopupModal } from "../index";
import "./ConfirmationModal.scss";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: ReactNode | string;
  confirmLabel?: string;
  cancelLabel?: string;
  isLoading?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = "Potwierdź",
  cancelLabel = "Anuluj",
  isLoading = false,
}) => {
  return (
    <PopupModal isOpen={isOpen} onClose={onClose}>
      <div className="confirmation-modal">
        <div className="confirmation-modal__header">
          <h2 className="popup-modal__header">{title}</h2>
        </div>

        <div className="confirmation-modal__content">
          <p className="confirmation-modal__message">{message}</p>
        </div>

        <div className="popup-modal__buttons">
          <Button
            label={cancelLabel}
            styleType="stroke"
            onClick={onClose}
            type="button"
            disabled={isLoading}
          />
          <Button
            label={confirmLabel}
            styleType="primary"
            onClick={onConfirm}
            type="button"
            disabled={isLoading}
          />
        </div>
      </div>
    </PopupModal>
  );
};

export default ConfirmationModal;
